// extracted by mini-css-extract-plugin
export default {"container":"PaymentsPage_container__ZAw60","loadWrapp":"PaymentsPage_loadWrapp__ghi2C","loadSpin":"PaymentsPage_loadSpin__pYLmh","spinner":"PaymentsPage_spinner__tP1A0"};